import React, { useState } from 'react';

import CardDialog from '~/components/CardDialog';
import Button from '~/components/core/Atomic/Buttons/Button';
import ButtonsContainer from '~/components/core/Atomic/Buttons/ButtonsContainer';
import CancelButton from '~/components/core/Buttons/CancelButton';
import Text from '~/components/core/TextComponents/Text';
import { reportAxiosError } from '~/Utils';

interface ESignConfigurationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => Promise<void>;
}

const ESignConfigurationDialog: React.FC<ESignConfigurationDialogProps> = ({ isOpen, onClose, onSubmit }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isOpen) {
    return null;
  }

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      await onSubmit();
      setIsSubmitting(false);
      onClose();
    } catch (error) {
      reportAxiosError(error);
      setIsSubmitting(false);
    }
  };

  return (
    <CardDialog
      isDialog
      title="Create E-Sign Configuration"
      onClose={onClose}
      preventClose={isSubmitting}
      maxWidth="md"
      fullWidth
    >
      <div className="flex flex-col space-y-8">
        <div>
          <Text variant={Text.VARIANTS.SM} weight={Text.WEIGHTS.REGULAR} colorVariant={Text.COLOR_VARIANTS.PRIMARY}>
            This will create a Dropbox Sign API app for your organization automatically. The app will be configured with
            the necessary permissions and callback URLs to enable electronic signature functionality.
          </Text>
        </div>

        <div>
          <Text variant={Text.VARIANTS.SM} weight={Text.WEIGHTS.REGULAR} colorVariant={Text.COLOR_VARIANTS.PRIMARY}>
            Once created, you can enable or disable the integration at any time. No additional configuration is required
            - the system will handle all technical details automatically.
          </Text>
        </div>

        <ButtonsContainer>
          <CancelButton disabled={isSubmitting} onClick={onClose} />
          <Button variant="contained" color="primary" disabled={isSubmitting} onClick={handleSubmit}>
            CREATE CONFIGURATION
          </Button>
        </ButtonsContainer>
      </div>
    </CardDialog>
  );
};

export default ESignConfigurationDialog;
